import React from 'react';
import { Modal } from 'antd';
import { SafetyOutlined, CloseOutlined } from '@ant-design/icons';

interface SecurityAvailabilityModalProps {
  visible: boolean;
  onClose: () => void;
  onConfigure: () => void;
  onDismiss: () => void;
  onDontShowAgain: () => void;
}

const SecurityAvailabilityModal: React.FC<SecurityAvailabilityModalProps> = ({
  visible,
  onClose,
  onConfigure,
  onDismiss,
  onDontShowAgain,
}) => {
  return (
    <Modal
      title={
        <div className="flex items-center">
          <SafetyOutlined className="text-blue-600 mr-2" />
          <span className="text-lg font-semibold">Enhanced Security Available</span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width={480}
      centered
      closeIcon={<CloseOutlined />}
      className="security-availability-modal"
      maskClosable={false}
      keyboard={false}
      closable={true}
    >
      <div className="py-4">
        <div className="mb-4">
          <div className="flex items-center mb-3">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-3">
              <SafetyOutlined className="text-blue-600 text-xl" />
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-900">Protect Your Account</h3>
              <p className="text-sm text-gray-600">Add an extra layer of security</p>
            </div>
          </div>
        </div>

        <div className="mb-6">
          <p className="text-gray-700 mb-3">
            You can set up Two-Factor Authentication (2FA) for additional security. 
            This is optional but highly recommended to protect your account from unauthorized access.
          </p>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
            <h4 className="font-medium text-blue-900 mb-2">Benefits of 2FA:</h4>
            <ul className="text-sm text-blue-800 space-y-1">
              <li>• Extra protection against password breaches</li>
              <li>• Secure access even if your password is compromised</li>
              <li>• Industry-standard security practice</li>
            </ul>
          </div>
        </div>

        <div className="flex space-x-3">
          <button
            onClick={onConfigure}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Configure 2FA
          </button>
          <button
            onClick={onDismiss}
            className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-2.5 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            Maybe Later
          </button>
        </div>

        <div className="mt-4 text-center">
          <button
            onClick={onDontShowAgain}
            className="text-sm text-gray-500 hover:text-gray-700 underline"
          >
            Don't show this in a month
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SecurityAvailabilityModal;
